import React from "react";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import Dialog from "../../../library/Dialog";
import PartnersTab from "../PartnersTab";

export default function PartnersDialog({
  open,
  onClose,
  campaigns,
  loading,
  error,
  busy,
  reviewing,
  issuedKey,
  onIssuedKey,
  onDismissKey,
  onRefresh,
  onReview,
  onSnack,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title='Manage partners'
      subtitle='Manage partner offers, code expiry, and API access.'
      icon={<HandshakeOutlinedIcon />}
      loading={busy || reviewing}
      maxWidth='lg'
      paperSx={{
        height: 720,
        maxHeight: { xs: "calc(100% - 32px)", sm: "calc(100% - 64px)" },
      }}
      contentSx={{
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
        "& > fieldset": {
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        },
      }}
      cancelText='Close'
      hideConfirmButton
    >
      <PartnersTab
        campaigns={campaigns}
        loading={loading}
        error={error}
        busy={busy}
        issuedKey={issuedKey}
        onIssuedKey={onIssuedKey}
        onDismissKey={onDismissKey}
        onRefresh={onRefresh}
        onReview={onReview}
        onSnack={onSnack}
      />
    </Dialog>
  );
}
